<template>
  <div>
    <div class="tipDiv">
      <p>若您在线申请过版面定制储蓄卡，可查询办卡进度</p>
    </div>
    <b-container fluid>
      <div>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">姓名</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="name"
              id="input-name"
              type="text"
              placeholder="办卡人姓名"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="办卡预留手机号"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />

        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <div @click="queryBankSn()" class="button" :disabled="disabled">
              查询
            </div>
            <!-- <b-button
              block
              @click="queryBankSn()"
              variant="danger"
              :disabled="disabled"
              >查询</b-button
            > -->
          </b-col>
        </b-row>
      </div>
      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">查询中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("@/common/config.js");
import { mobile_pattern } from "@/js/verifyData";
export default {
  name: "QueryOrder_demo",
  data() {
    return {
      name: "",
      mobile: "",
      disabled: true,
      loading: false,
      showToast: false,
      toastMsg: "",
    };
  },
  watch: {
    name: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (this.name.length > 0 && this.mobile.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    mobile: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (this.mobile.length > 0 && this.name.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    queryBankSn: function () {
      const pattMobile = mobile_pattern;
      if (
        this.name.length == 0 ||
        this.name.length < 2 ||
        this.name.length > 15
      ) {
        this.showToastMsg("您输入的姓名长度不符合要求，请重新输入");
        return;
      }

      if (!pattMobile.test(this.mobile)) {
        this.showToastMsg("请输入正确的手机号");
        return;
      }

      var that = this;
      let param = {
        clientName: this.name,
        clientPhoneNumber: this.mobile,
        bankCode: config.config_demo.bankCode,
      };

      that.showLoading();
      axios
        .post(config.config_demo.queryBankSerialNumbers, param)
        .then(function (response) {
          console.log(response);
          let data = response.data;
          if (data.code == 0) {
            that.toOrderList(data.serialList);
          } else {
            that.hideLoading();
            that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    queryOrder: function (data) {
      let bankCodeList = new Set();
      let set = new Set();

      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        set.add(item.bankCode);
      }

      for (var bankCode of set) {
        // 遍历Set
        var item = new Object();
        item.bankCode = bankCode;
        item.serialList = new Set();

        for (var codeAndSerial of data) {
          var tempBankCode = codeAndSerial.bankCode;
          if (item.bankCode == tempBankCode) {
            item.serialList.add(codeAndSerial.bankSerialNumber);
          }
        }
        bankCodeList.add(item);
      }

      console.log(JSON.stringify(bankCodeList));

      var that = this;
      axios
        .post(config.config_demo.queryOrder, {
          bankCodeList: bankCodeList,
          pageIndex: 0,
          pageSize: 4,
        })
        .then(function (response) {
          /* {
            "code": 0,
            "message": null,
            "projectName": "DIY",
            "orderModelList": [{
              "orderNo": "01222404618637029376",
              "orderDateTime": "2020-03-10 14:12:50",
              "orderStatus": "制卡完成",
              "orderStatsNo": 8,
              "courierCompany": "",
              "trackNumber": "",
              "orderType": "1",
              "price": 1,
              "auditFailCause": null,
              "modelType": 0,
              "modelClass": 0,
              "backgroundColor": "201C",
              "cardClass": 1,
              "address": "北京市西城区新盛大厦B-8层",
              "orderStep": 3,
              "cardTypeName": "借记卡",
              "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
            }]
          } */
          that.hideLoading();
          console.log(response);
          var data = response.data;
          var dataString = JSON.stringify(data);
          console.log(dataString);

          if (data.code == 0) {
            var orders = data.orderModelList;
            var obj = {
              projectName: data.projectName,
              orders: orders,
            };
            that.toOrderList(obj);
          } else {
            that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    toOrderList: function (bankSerialObj) {
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.push({
        name: "OrderList_demo",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
  },
};
</script>

<style scoped>
.rowBtn {
  margin-top: 3rem;
}

.tipDiv {
  width: 100%;
  background-color: #f9ecd0;
  height: 1.8rem;
  color: #a66e36;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: left;
}
.button {
  width: 100%;
  height: 2.8rem;
  border-radius: 1.4rem;
  background-color: #3861d5;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 auto;
  margin-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/CheckProgress/QueryOrder_demo.vue